export const gateway_web = 'gateway_web';

export const file_web = 'file_web';